import {
  Typography,
  TypographyVariant,
  TypographyWeight,
} from 'src/components/atoms'
import { Table } from 'src/components/organisms'
import { Column, Data } from 'src/components/organisms/table/types'

import { IInsightEntity } from '../types'

interface IInsightsTableProps {
  insights: IInsightEntity[]
  onRowClick: (insight: IInsightEntity) => void
}

const asInsight = (row: Data): IInsightEntity =>
  row as unknown as IInsightEntity

export const InsightsTable = ({
  insights,
  onRowClick,
}: IInsightsTableProps): JSX.Element => {
  const columns: Column[] = [
    {
      property: 'reportName',
      header: 'Report Name',
      width: '400px',
      renderRowCell: row => {
        const insight = asInsight(row)
        return (
          <td className="pr-6">
            <Typography
              variant={TypographyVariant.title2Xs}
              weight={TypographyWeight.light}
              className="text-content-primary"
            >
              {insight.reportName}
            </Typography>
          </td>
        )
      },
    },
    {
      property: 'category',
      header: 'Category',
      renderRowCell: row => {
        const insight = asInsight(row)
        return (
          <td className="pr-6">
            <Typography
              variant={TypographyVariant.bodyXs}
              className="text-content-secondary"
            >
              {insight.category}
            </Typography>
          </td>
        )
      },
    },
    {
      property: 'contentCoverage',
      header: 'Content Coverage',
      renderRowCell: row => {
        const insight = asInsight(row)
        return (
          <td className="pr-6">
            <Typography
              variant={TypographyVariant.bodyXs}
              className="text-content-secondary"
            >
              {insight.contentCoverage}
            </Typography>
          </td>
        )
      },
    },
    {
      property: 'producer',
      header: 'Producers',
      renderRowCell: row => {
        const insight = asInsight(row)
        return (
          <td className="pr-6">
            <Typography
              variant={TypographyVariant.bodyXs}
              className="text-content-secondary"
            >
              {insight.producer}
            </Typography>
          </td>
        )
      },
    },
    {
      property: 'releaseDate',
      header: 'Release Date',
      renderRowCell: row => {
        const insight = asInsight(row)
        return (
          <td className="pr-6">
            <Typography
              variant={TypographyVariant.bodyXs}
              className="text-content-secondary"
            >
              {insight.releaseDate}
            </Typography>
          </td>
        )
      },
    },
  ]

  return (
    <Table
      columns={columns}
      data={insights as unknown as Data[]}
      idPropertyName="id"
      onRowClick={row => onRowClick(asInsight(row))}
    />
  )
}
